import { BusinessPayments } from '../../../../components/service/business/BusinessPayments';
export const BusinessPaymentsPageView = () => {
  return <BusinessPayments data-sentry-element="BusinessPayments" data-sentry-component="BusinessPaymentsPageView" data-sentry-source-file="business-payments.tsx" />;
};